export type AsyncImport = {
    load: () => Promise<any>;
    cancel: () => void;
};
export type FeatureFetchCallback = (featureNamespace: string, featureName: string) => AsyncImport;

let featureForAppCallback: FeatureFetchCallback;
export function setFeatureForAppCallback(callback: FeatureFetchCallback) {
    featureForAppCallback = callback;
}

export const asyncImport = (promisedImport: Promise<any>): AsyncImport => {
    let importIsCanceled = false;

    const load = (): Promise<any> => {
        return new Promise((resolve, reject) => {
            promisedImport.then(
                (component) => (importIsCanceled ? reject({ isCanceled: true }) : resolve(component)),
                (error) => (importIsCanceled ? reject({ isCanceled: true }) : reject(error)),
            );
        });
    };

    const cancel = (): void => {
        importIsCanceled = true;
    };

    return {
        load,
        cancel,
    };
};

const dynamicFetchFeatureComponent = (featureNamespace: string, featureName: string): AsyncImport => {
    if (featureForAppCallback) {
        return featureForAppCallback(featureNamespace, featureName);
    }
    throw Error('No featureForAppCallback is set');
};

export default dynamicFetchFeatureComponent;
